import React from 'react';

import classes from './Spinner.module.scss';

const spinner = () => <div className = { classes.Spinner } />

export default spinner;
